export default [
	{
		path: '/home/bes/robo-advise',
		name: 'roboAdvise',
		meta: {
			title: 'Bireysel Emeklilik - Robo Advise',
			layout: 'default'
		},
		component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/Home.vue')
	},
	{
		path: '/robo-advise',
		name: 'roboAdviseStart',
		redirect: { name: 'roboAdviseWelcome' },
		meta: {
			title: 'Bireysel Emeklilik - Robo Advise',
			layout: 'robo'
		},
		component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/Start.vue'),
		children: [
			{
				path: 'welcome',
				name: 'roboAdviseWelcome',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Start.vue'),
			},
			{
				path: 'contracts',
				name: 'roboAdviseContracts',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Contracts.vue'),
			},
			{
				path: 'risk-profile',
				name: 'roboAdviseRiskProfile',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/RiskProfile.vue'),
			},
			{
				path: 'yerindelik',
				name: 'roboAdviseYerindelik',
				meta: {
					title: 'Bireysel Emeklilik - Robo Advise',
					layout: 'robo'
				},
				component: () => import(/* webpackChunkName: "bes" */ '@/views/individual/bes/robo/content/Yerindelik.vue'),
			}
		]
	}
]